import { render, staticRenderFns } from "./ReportWitness.vue?vue&type=template&id=0ee51d79&"
import script from "./ReportWitness.vue?vue&type=script&lang=ts&"
export * from "./ReportWitness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports